import type { Countertop } from '../../countertops/countertop.class';
import type { Island } from '../../islands/island.class';

/**
 * The island whose front-panel axis a countertop's breakpoints are measured along.
 * A countertop can span several islands; the first is the run's frame of reference,
 * matching the Align Left / Align Right context-menu items and the DXF writer.
 * @param countertop the countertop owning the breakpoints
 * @returns the owning Island, or null when it cannot be resolved
 */
export const getCountertopRunIsland = (countertop: Countertop): Island | null => {
	if (!countertop) return null;
	const [islandId = null] = countertop.islandIds ?? [];
	if (!islandId) return null;

	return countertop.refMap?.kitchen?.design?.islands?.findById(islandId) ?? null;
};
